import { BannerCreate_bannerCreate_errors } from "@saleor/banners/types/BannerCreate";
import { commonMessages } from "@saleor/intl";
import { BannerErrorCode } from "@saleor/types/globalTypes";
import { IntlShape } from "react-intl";

import commonErrorMessages from "./common";

function getBannerErrorMessage(
  err: Omit<BannerCreate_bannerCreate_errors, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case BannerErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case BannerErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getBannerErrorMessage;
